import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pageTitle: {
		id: 'confluence.page.preview.panel.pageTitle',
		defaultMessage: 'Confluence Page',
	},
	whiteboardTitle: {
		id: 'confluence.page.preview.panel.whiteboardTitle',
		defaultMessage: 'Confluence Whiteboard',
	},
});
